import { useEffect } from "react";
import { useParams } from "react-router";
import FullScreenLoadingSpinner from "src/components/shared/loading/FullScreenLoadingSpinner";
import { LOBBIE_STORAGE, UNKNOWN } from "src/constants";
import { useAnonmyousPatientV2 } from "src/hooks/patients/useAnonymousPatientV2";
import { handleError, sessionSet } from "src/utils";

const ANONYMOUS_DATE_OF_BIRTH = "1/1/1900";

const AnonymousPatientSingleFormPublicV2: React.FC = () => {
    const {
        formTemplatePublicUuid,
        accountPublicUuid,
        locationId,
    }: {
        accountPublicUuid: string | undefined;
        formTemplatePublicUuid: string | undefined;
        locationId: string | undefined;
    } = useParams();

    const { create: createAccountPatient } = useAnonmyousPatientV2(accountPublicUuid, {
        formTemplatePublicUuid,
        locationId,
    });

    useEffect(() => {
        createAccountPatient(UNKNOWN, UNKNOWN, ANONYMOUS_DATE_OF_BIRTH)
            .then(() => {
                sessionSet(
                    LOBBIE_STORAGE.Session.Patients.Forms.VerifiedDateOfBirth,
                    ANONYMOUS_DATE_OF_BIRTH,
                );
            })
            .catch(handleError);
    }, [createAccountPatient]);

    return <FullScreenLoadingSpinner message={["Loading Form..."]} />;
};

export default AnonymousPatientSingleFormPublicV2;
